import oauthSettings from './vsko-oauth-configuration-stripped.json';

export const api = 'https://api.katholiekonderwijs.vlaanderen';
export const cachedApi = 'https://cached-api.katholiekonderwijs.vlaanderen';
export const oauth = oauthSettings;